import { memo } from 'react';

import MaximizeIconSVG from '@/assets/maximize-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IMaximizeIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={MaximizeIconSVG} {...props} />;

export const MaximizeIcon = memo(IMaximizeIcon) as typeof IMaximizeIcon;
